/**
 * Login Component
 * 
 * Displays when user is not authenticated.
 * Provides Azure AD login button and branding.
 */

import React from 'react';
import { useMsal } from '@azure/msal-react';
import { loginRequest } from '../authConfig';
import './Login.css';
import logo from '../P2S_Legence_Logo_White.png';

const Login = () => {
  const { instance } = useMsal();

  const handleLogin = async () => {
    try {
      await instance.loginPopup(loginRequest);
    } catch (error) {
      console.error('Login failed:', error);
      
      // Show user-friendly error
      if (error.errorCode === 'popup_window_error') {
        alert('Popup was blocked. Please allow popups for this site and try again.');
      } else if (error.errorCode === 'user_cancelled') {
        // User cancelled - no action needed
      } else {
        alert('Login failed. Please try again.');
      }
    }
  };

  return (
    <div className="login-page-layout">
      {/* Top Header with Small Logo */}
      <div className="header">
        <img src={logo} alt="P2S Logo" className="header-logo" />
      </div>

      {/* Main Content - Centered */}
      <div className="main-content">
        <div className="login-container">
          {/* Large Centered Logo */}
          <img src={logo} alt="P2S Logo" className="main-logo" />
          
          {/* Microsoft Sign In Button */}
          <button className="login-button" onClick={handleLogin}>
            <svg className="microsoft-icon" viewBox="0 0 23 23" xmlns="http://www.w3.org/2000/svg">
              <path fill="#f35325" d="M0 0h11v11H0z"/>
              <path fill="#81bc06" d="M12 0h11v11H12z"/>
              <path fill="#05a6f0" d="M0 12h11v11H0z"/>
              <path fill="#ffba08" d="M12 12h11v11H12z"/>
            </svg>
            Sign In with Microsoft
          </button>
        </div>
      </div>

      {/* Footer */}
      <div className="footer">
        <div className="footer-left">
          <span className="footer-text">About</span>
        </div>
        <div className="footer-right">
          <a href="https://www.p2sinc.com" target="_blank" rel="noopener noreferrer">www.p2sinc.com</a>
          <span> | © 2025 P2S All rights reserved.</span>
        </div>
      </div>
    </div>
  );
};

export default Login;
